<template>
  <div class="bgf4">
    <div class="abc">
    <div class="box bgfff" style="display:block;margin:20px auto;padding:20px 0 20px 20px;">
      <!-- 左侧菜单栏 -->
      <div class="fleft  cleft">

          <!-- <span style="margin-left:10px">通知公告</span> -->

        <ul class="cleftUl">
          <a-menu mode="inline" :open-keys.sync="openKeys"  @click="handleClick" class="mezt" :default-selected-keys="openKeys1">
                <template v-for="i in treeList" style="display: none;">
                  <a-menu-item class="ali"
                    :key="i.itemValue"
                  >
                    <!-- <div class="firmTitle bgblue" v-if="select==true">
                    <img src="../../images/jt.png">
                    <span>{{ i.itemText }}</span></div> -->
                    <!-- <img src="../../images/jt.png" style="float:left;margin-top:10px"> -->
                    <span v-if="select==false">{{ i.itemText }}</span>
                  </a-menu-item>
                </template>
          </a-menu>
        </ul>
      </div>
      <!-- 右侧列表部分 -->
      <div class="fright  cright" style="padding-right: 20px;" v-if="!showDetail">
        <a-list item-layout="horizontal" :data-source="data" :class="[data.length>0?'alist':'']" :pagination="false">
          <a-list-item slot="renderItem" slot-scope="item, index">
            <span class="blueCircle"></span>
            <a-list-item-meta>
              <a slot="title" class="fontlist" @click="statedetial(item.id)"><span class="wbyc" :title="item.title">{{ item.title }}</span></a>
            </a-list-item-meta>
            <span class="fontlist">{{ item.publishdate }}</span>
          </a-list-item>
        </a-list>
        <div class="fy" v-if="data.length>0">
          <span style="margin-top:4px;margin-right:5px">共&nbsp;{{total}}&nbsp;条记录</span>
          <div class="fir"><a @click="btnfir" :disabled="disabled" ref="fa">首页</a></div>
          <a-config-provider :locale="locale">
          <a-pagination  :total="ipagination.total" :item-render="itemRender" :pagination="ipagination"
          v-model="ipagination.pageNo" @change='changePage'>
          </a-pagination>
          </a-config-provider>
          <div class="end"><a ref="end" :disabled="disablede" @click="endbtn">末页</a></div>
          <span style="margin-left:5px">跳至&nbsp;<a-input type="text" v-model="text" @blur="changeText" style="width:50px;border:normal" />&nbsp;页</span>
        </div>
      </div>
      <!--详情页-->
      <div class="fright  cright" v-if="showDetail">
        <AquaticStateDetial></AquaticStateDetial>
      </div>
    </div>
    </div>
  </div>
</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import AquaticStateDetial from './AquaticStateDetial';

export default {
  name: 'App',
  components: {
    AquaticStateDetial
  },
  data(){
    return{
      showDetail: false,
      selectMenu: '0',
      select:false,
      disabled:false,
      disablede:false,
      locale: zhCN,
      ipagination:{
        current: 1,
        pageNo:1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      treeList: [
      ],
      data:[],
      id:'',
      openKeys:[],
      openKeys1:[],
      total:0,
      text:null
    }
  },
  computed:{

  },
  created(){
    if(this.$route.query.id){//显示详情
      this.showDetail = true;
    }
    if(this.ipagination.total=='0'){
      this.disablede = true
      this.disabled = true
    }
    this.query()

  },
  mounted () {

  },
  watch: {
    openKeys(val) {

    },
    ipagination: {
        handler(newVal) {
            setTimeout(() => {
              if(newVal.pageNo=='1' && newVal.total!='0'){
              this.disabled = true
              this.$refs.fa.style.color = '#bfbfbf'
            }else if(newVal.total!='0'){
              this.disabled = false
              this.$refs.fa.style.color = '#595959'
            }


            let end = newVal.total/newVal.pageSize
            end = Math.ceil(end)
            if(newVal.current!=end && newVal.total!='0'){
              this.disablede = false
              this.$refs.end.style.color = '#595959'
            }else if(newVal.current==end){
              this.$refs.end.style.color = '#bfbfbf'
              this.disablede = true
            }
            }, 100);
        },
        deep: true
    }
  },
  methods: {
    changeText(e){
      var i = parseInt(e.target.value)
      let end = this.total/this.ipagination.pageSize
      end = Math.ceil(end)
      if(i>end){
        this.ipagination.current = end
        this.ipagination.pageNo = end
        this.text = null
      }else if(i==0){
        this.ipagination.current = 1
        this.ipagination.pageNo = 1
        this.text = null
      }else if(e.target.value==null || e.target.value==''){

      }else{
        this.ipagination.current = i
        this.ipagination.pageNo = i
        this.text = i
      }
      this.queryAquaticStatelx(this.id);

    },
    statedetial(id){
      let path = this.$router.history.current.path;
      this.$router.push({ path, query: {id: id, selectMenu: this.selectMenu}});
      this.showDetail = true;
      //window.open('statedetial?id='+id)
    },
    handleClick(e){
      this.showDetail = false;
      // this.select = true
      if(this.text!=null){
        this.text=null
      }
      if(this.ipagination.pageNo!=1){
        this.ipagination.pageNo=1
      }
      this.id = e.key
      this.queryAquaticStatelx(e.key)
      this.selectMenu = e.key;

    },
    queryAquaticStatelx(value){
      http.get('/queryAquaticStatelx',{params:{trendstype:value,pageNo:this.ipagination.pageNo}}
      ).then((res) => {
          this.data = res.data.result.records
          this.ipagination.total = res.data.result.total
          this.ipagination.current = res.data.result.current
          this.total=res.data.result.total
      })
    },
    query(){
      http.get('/queryDictDatalistScdt',{}
      ).then((res) => {
          this.treeList = res.data.result[0].children;
          for(var a=0;a<this.treeList.length;a++){
            if(this.treeList[a].itemText=="公示"){
              this.treeList[a].sortOrder=3
            }
            if(this.treeList[a].itemText=="通知"){
              this.treeList[a].sortOrder=1
            }
            if(this.treeList[a].itemText=="立项"){
              this.treeList[a].sortOrder=2
            }
            if(this.treeList[a].itemText=="发布"){
              this.treeList[a].sortOrder=4
            }
          }
          this.sortKey(this.treeList,"sortOrder")
          if(this.$route.query.selectMenu){//选中详情所属的分类
            this.openKeys1.push(this.$route.query.selectMenu);
          } else {//选中第一个
            this.openKeys1.push(this.treeList[0].itemValue);
          }
          this.id = this.openKeys1[0];
          this.queryAquaticStatelx(this.openKeys1[0]);
      })
    },
    sortKey(arr,key){
      return arr.sort(function(a,b){
        var x=a[key]
        var y=b[key]
        return ((x<y)?-1:(x>y)?1:0)
      })
    },
    endbtn(){
      if(this.text!=null){
        this.text=null
      }
      let end = this.ipagination.total/this.ipagination.pageSize
      end = Math.ceil(end)
      this.ipagination.pageNo = end
      this.queryAquaticStatelx(this.id)
    },
    btnfir(){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = 1;
      this.queryAquaticStatelx(this.id)
    },
    changePage(e){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = e;
      this.queryAquaticStatelx(this.id)
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <div class="pre"><a>上一页</a></div>;
      } else if (type === 'next') {
        return <div class="next"><a>下一页</a></div>;
      }
      return originalElement;
    },
  },
}
</script>


<style scoped>
@import "../../config/AquaticState.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticstate/AquaticState.vue